import { render, staticRenderFns } from "./MyModules.vue?vue&type=template&id=55174cb4&scoped=true"
import script from "./MyModules.vue?vue&type=script&lang=js"
export * from "./MyModules.vue?vue&type=script&lang=js"
import style0 from "./MyModules.vue?vue&type=style&index=0&id=55174cb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55174cb4",
  null
  
)

export default component.exports